import React from 'react';
import { Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'I never thought I could eat bread again without guilt. This program changed my life.',
    author: 'Emily R.',
    role: 'Durham, NC'
  }, {
    quote: "Compassionate, knowledgeable, and realistic. The best investment I've made for my health.",
    author: 'Michael T.',
    role: 'Virtual Client'
  }, {
    quote: 'Finally, a nutritionist who listens instead of just handing me a meal plan.',
    author: 'Jessica K.',
    role: 'Clemmons, NC'
  }];
  return <section className="py-24 bg-emerald-900 text-emerald-50" data-id="element-140">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-141">
        <div className="text-center mb-16" data-id="element-142">
          <h2 className="font-serif text-3xl font-bold sm:text-4xl" data-id="element-143">
            Stories from our community
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-144">
          {testimonials.map((t, i) => <div key={i} className="bg-emerald-800/50 p-8 rounded-3xl border border-emerald-700/50 relative" data-id="element-145">
              <Quote className="absolute top-8 left-8 h-8 w-8 text-emerald-600/50" data-id="element-146" />
              <p className="relative z-10 text-lg leading-relaxed mb-6 pt-6" data-id="element-147">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3" data-id="element-148">
                <div className="h-10 w-10 rounded-full bg-emerald-200/20" data-id="element-149" />
                <div data-id="element-150">
                  <p className="font-bold text-sm" data-id="element-151">{t.author}</p>
                  <p className="text-xs text-emerald-300" data-id="element-152">{t.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}